import * as Yup from "yup";
import { LegacyGeozoneType, TLegacyGeozone } from "../../../api/types/Geozone";
import { APP_CONFIG } from "../../../constants/constants";

// form field names
export type TFormFieldNames =
  | "geozoneid"
  | "description"
  | "zonetype"
  | /*"lat_lng" | */ "priority"
  | "reversegeocode"
  | "arrivalzone"
  | "departurezone"
  | "shapecolor"
  | "speedlimitkph";

type Modify<T, R> = Pick<T, Exclude<keyof T, keyof R>> & R;
export type TGeozoneDetailsInitialValues = Modify<
  TLegacyGeozone,
  {
    latitude1: number | null;
    longitude1: number | null;
    latitude2: number | null;
    longitude2: number | null;
    latitude3: number | null;
    longitude3: number | null;
    latitude4: number | null;
    longitude4: number | null;
    latitude5: number | null;
    longitude5: number | null;
    latitude6: number | null;
    longitude6: number | null;
    latitude7: number | null;
    longitude7: number | null;
    latitude8: number | null;
    longitude8: number | null;
    latitude9: number | null;
    longitude9: number | null;
    latitude10: number | null;
    longitude10: number | null;
    reversegeocode: boolean;
    arrivalzone: boolean;
    departurezone: boolean;
  }
>; // & { polygonsides: number };

// initial values for the form
export const geozoneDetailsInitialValues: Partial<TGeozoneDetailsInitialValues> =
  {
    // : Partial<TLegacyGeozone> & { assign_group: TSelectboxOption[] }
    geozoneid: "",
    // properties: {},
    arrivalzone: true,
    departurezone: true,
    description: "",
    // city: "",
    groupid: "",
    postalcode: "",
    priority: 0,
    reversegeocode: true,
    shapecolor: "",
    speedlimitkph: 0,
    stateprovince: "",
    streetaddress: "",
    zonetype: LegacyGeozoneType.CIRCLE,
    radius: APP_CONFIG.MAPS.DEFAULTS.RADIUS,
  };

// validation schema for the form
export const geozoneDetailsYupValidationSchema = Yup.object().shape({
  description: Yup.string()
    .required("Description is required")
    .max(128, "Description must be at most 128 characters"),
  streetaddress: Yup.string().required("Street Address is required"),
  zonetype: Yup.string().required("Zone Type is required"),
  // lat_lng: Yup.string().required("Lat/Lng is required"),
  priority: Yup.number().required("Overlap Priority is required"),
  // reverse_geocode: Yup.boolean().required("Reverse Geocode is required"),
  // arrival_geozone: Yup.boolean().required("Arrival Geozone is required"),
  // departure_zone: Yup.boolean().required("Departure Zone is required"),
  // shapecolor: Yup.string().required("Zone Color is required"),

  // TODO: Needs fixing
  // radius: Yup.number()
  //   .when('zonetype', ([zonetype], schema) => {
  //     return schema.test({
  //       test: (value) => {
  //         return !!value || zonetype === LegacyGeozoneType.ROUTE;
  //       },
  //       message: "Corridor Radius must be greater than or equal to 50 meters",
  //     })
  //   }
  //   ),
  radius: Yup.number()
    .typeError("Please enter a numeric value")
    .when("zonetype", ([zonetype], schema) => {
      const isCircle =
        zonetype?.toString() === LegacyGeozoneType.CIRCLE.toString();
      const isRoute =
        zonetype?.toString() === LegacyGeozoneType.ROUTE.toString();
      if (isCircle || isRoute) {
        return schema
          .required("Radius is required")
          .min(50, "Radius must be at least 50 meters")
          .max(65000, "Radius cannot exceed 65,000 meters");
      }
      return schema.nullable();
    }),

  speedlimitkph: Yup.number()
    .typeError("Please enter a numeric value")
    .test(
      "max-2-decimals",
      "Speed Limit can have at most 2 decimal places",
      (value) => {
        if (value === undefined || value === null || (value as any) === "")
          return true;
        // Check if value is integer or has at most 2 decimal places
        return /^\d+(\.\d{1,2})?$/.test(value.toString());
      }
    ),
});
